










import { Component, Vue } from 'vue-property-decorator';
import BookingEventTable from '@bookings/components/tables/booking-event-table/booking-event-table.vue';

@Component({
  name: 'bc-booking-event-payment-follow-up',
  components: {
    'bpc-booking-event-table': BookingEventTable,
  },
})
export default class BookingEventPaymentFollowUp extends Vue {}
